import type { MouseEvent } from "react";
import { scrollToSection } from "@/pages/home/utils/scrollTo";

export default function HeroSection() {
  const go = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    scrollToSection(id);
  };

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dark%20warm-toned%20background%20with%20glowing%20amber%20and%20emerald%20flowing%20ribbon%20lines%20forming%20connected%20network%20routes%2C%20deep%20charcoal%20base%2C%20cinematic%20soft%20lighting%2C%20high%20contrast%2C%20minimalist%20tech%20aesthetic%2C%20subtle%20grain%2C%20no%20text&width=1920&height=1080&seq=hero-91free-main&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(255,180,90,0.22),transparent_60%)]" />

      <div className="relative z-10 w-full px-4 md:px-8 py-28 md:py-36">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-50 text-xs md:text-sm mb-6">
            <i className="ri-live-line text-accent-400" />
            页面最近更新：2026-10-10 09:30 · 已同步 6 条可用线路
          </span>

          <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl leading-tight text-background-50">
            91免费 最新地址发布页
            <span className="block mt-3 text-2xl md:text-4xl lg:text-5xl text-primary-300">
              防走失入口，直达官网不迷路
            </span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-background-50/85 leading-relaxed max-w-2xl mx-auto">
            当 91免费 的官网地址发生变动时，本页会同步更新当前可用的入口地址。无论你在电脑还是手机上，打开这一页就能重新找到有效地址，不必再为「收藏的网址打不开」而苦恼。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#addresses"
              onClick={(e) => go(e, "addresses")}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-link-m text-lg" />
              查看最新可用地址
            </a>
            <a
              href="#guide"
              onClick={(e) => go(e, "guide")}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border border-background-50/40 text-background-50 text-base font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              <i className="ri-bookmark-3-line text-lg" />
              防走失指南
            </a>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
            {[
              { icon: "ri-refresh-line", title: "每日多次同步", desc: "地址变动后尽快更新" },
              { icon: "ri-list-check-3", title: "主线路 + 备用线路", desc: "一条不通就换下一条" },
              { icon: "ri-shield-check-line", title: "不索取账号信息", desc: "纯导航，无需注册登录" },
            ].map((item) => (
              <div
                key={item.title}
                className="flex items-center gap-3 px-4 py-3 rounded-lg bg-background-50/10 border border-background-50/15 text-left"
              >
                <span className="w-10 h-10 shrink-0 rounded-md bg-background-50/15 flex items-center justify-center text-accent-300">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <span className="flex flex-col">
                  <span className="text-background-50 text-sm font-medium">{item.title}</span>
                  <span className="text-background-50/70 text-xs">{item.desc}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}